import { useTranslation } from "react-i18next"
import { returnQueryWithPagination } from "../../../../../../../../utils/methods/returnQuery"
import { useLogbookContext } from "../../../../context"
import { formatUserMapFilter } from "../../../../utils"
import { useEffect } from "react"
import { LinearProgressDownload } from "../linearProgressDownload"
import { Box } from "@mui/material"
import { ModelDownloadButtons } from "../../../../../../../../components/donwloadFiles/model"
import { CustomeIconButton } from "../../../../../../../../components/customeIconButton"
import { icons } from "../../../../../../../../utils/icons"
import { useStyles } from "./styles"

export const DestinationsAction = () => {
    const { filter: { filterDestinations: { filter } }, service: { getReportDestination, getByUuidDestination }, state: { uuid, loading } } = useLogbookContext()
    const { t } = useTranslation()
    const styles = useStyles()
    const query = returnQueryWithPagination({ filter: filter.filterString }, formatUserMapFilter);

    const cleanFilterAll = () => {
        filter.cleanFilter()
    }

    const downloadCSV = () => {
        getReportDestination({ query, type: 'excel' })
    }

    const downloadPDF = () => {
        getReportDestination({ query, type:'pdf' })
    }

    const downloadWORD = () => {
        getReportDestination({ query, type:'word' })
    }

    useEffect(() => {
        if (uuid.DESTINATION) {
            const interval = setInterval(() => {
                getByUuidDestination({ uuid: uuid.DESTINATION })
            }, 30000);
            return () => clearInterval(interval);
        }
    }, [uuid.DESTINATION])

    return (<>
        <LinearProgressDownload show={loading.DESTINATION} text={t('loogbook.generateDestinations')} />

        <Box sx={styles.alignHorizontal}>
            <ModelDownloadButtons
                csv={downloadCSV}
                pdf={downloadPDF}
                word={downloadWORD}
                disableCSV={loading.DESTINATION}
                disablePDF={loading.DESTINATION}
                disableWORD={loading.DESTINATION}
                customeLabels={{
                    csv: t('general.csvDestinations'),
                    pdf: t('general.pdfDestinations'),
                    word: t('general.wordDestinations')
                }}
            />

            {!!filter.counter && <CustomeIconButton icon={icons('clean')} title={t('ToolTips.clearFilters')} iconButtonProps={{ sx: styles.filter, className: 'icon-size', ...{ onClick: cleanFilterAll } }} />}

        </Box>

    </>)
}